import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FalconOrder } from '@/store/orders/algoOrders/state.ts';

export const SavedFalconOrderValidator = arkScope.type({
  type: "'FalconOrder'",
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    clientWay: "'buy' | 'sell'",
    'notional?': 'number',
    notionalCurrencyIndex: 'CurrencyChoice',
    'limitPrice?': 'number',
    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      'tiering?': 'string',
    },
    isNdf: 'boolean',
    liquidityPool: 'string[]',
    'ndfFixingSource?': 'string',
    'ndfFixingDate?': 'string',
    'tenor?': 'string',
    startDate: {
      isNow: 'boolean',
      'date?': 'string',
      'time?': 'string',
    },
    expiryDate: {
      goodTillDate: 'boolean',
      'date?': 'string',
      'time?': 'string',
    },

    speed: "'VerySlow' | 'Slow' | 'Normal' | 'Fast' | 'VeryFast'",

    'notificationEmails?': 'string[]',
    isReadyToSubmit: 'boolean',
    'clockOffset?': 'number',
    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  'clientId?': 'number',
});

export type SavedFalconOrder = typeof SavedFalconOrderValidator.infer;

export const SavedFalconOrder = {
  fromFxFalconOrder: (fxTile: FalconOrder, tileId: string): SavedFalconOrder => ({
    type: 'FalconOrder',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
